import { Component } from '@angular/core';

@Component({
  selector: 'no-data',
  templateUrl: 'no-data.html'
})
export class NoDataComponent {

  text: string;

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/components/no-data/no-data.ts